export default {
  client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  prompt: 'select_account',
  scopes: {
    signIn: 'profile email',
    connectStore: 'profile email https://www.googleapis.com/auth/adwords',
    contentAPI: 'https://www.googleapis.com/auth/content',
  },
}
